export default __webpack_public_path__ + "static/media/jsxFun.d1f3d0da.png";